import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import cmsRootReducer from 'shared/lib/reducers';
import { cmsSwallowDispatchedPromiseMiddleware } from './cms-swallow-dispatched-promise.middleware';
const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export const cmsStore = createStore(cmsRootReducer, composeEnhancers(applyMiddleware(cmsSwallowDispatchedPromiseMiddleware, thunk, promiseMiddleware)));
